import { render, staticRenderFns } from "./g.vue?vue&type=template&id=95b93858&scoped=true&"
import script from "./g.vue?vue&type=script&lang=js&"
export * from "./g.vue?vue&type=script&lang=js&"
import style0 from "./g.vue?vue&type=style&index=0&id=95b93858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b93858",
  null
  
)

export default component.exports